export function getTabLabel(tabId: string, type: string): string {
  switch (type) {
    case 'creator':
      if (tabId === 'discography') return 'Content';
      if (tabId === 'tracks') return 'Episodes';
      if (tabId === 'albums') return 'Podcasts';
      break;
    case 'author':
      if (tabId === 'discography') return 'Publications';
      if (tabId === 'tracks') return 'Audiobooks';
      if (tabId === 'albums') return 'Chapters';
      break;
    default:
      if (tabId === 'discography') return 'Discography';
      if (tabId === 'tracks') return 'Tracks';
      if (tabId === 'albums') return 'Albums';
  }

  return tabId;
}

export function getPageLabel(label: string, type: string): string {
    switch (type) {
    case 'creator':
      if (label === 'Albums') return 'Podcasts';
      if (label === 'Similar artists') return 'Similar creators';
      break;
    case 'author':
      if (label === 'Albums') return 'Audiobooks';
      if (label === 'Similar artists') return 'Similar authors';
      break;
    default:
      if (label === 'Albums') return 'Albums';
      if (label === 'Similar artists') return 'Similar artists';
  }

  return label;
}